import React, { useState } from "react";
import localization from "../../statics/localization";

export default function InterfaceLanguageSwitch() {
 const [language,setLanguage] = useState(localization.getLanguage());
 const select = code => { localization.setLanguage(code); setLanguage(localization.getLanguage()); };
 if (process.env.REACT_APP_ENGLISH_PRESENTATION === "true" && process.env.REACT_APP_ARABIC_UI !== "true") return null;
 return <nav className="interface-language-switch" aria-label={language === "arb" ? "لغة الواجهة" : "Interface language"}>
  <button type="button" lang="en" aria-pressed={language === "eng"} onClick={() => select("eng")}>English</button>
  <button type="button" lang="ar" aria-pressed={language === "arb"} onClick={() => select("arb")}>العربية</button>
 </nav>;
}
